var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9502 27.4585H3.73752C3.0498 27.4585 2.4917 26.9003 2.4917 26.2127V3.78738C2.4917 3.09967 3.04986 2.54156 3.73752 2.54156H14.9502C15.6391 2.54156 16.196 1.98469 16.196 1.29574C16.196 0.606797 15.6391 0.0498047 14.9502 0.0498047H3.73752C1.67689 0.0498047 0 1.72676 0 3.78738V26.2126C0 28.2732 1.67689 29.9501 3.73752 29.9501H14.9502C15.6391 29.9501 16.196 29.3933 16.196 28.7043C16.196 28.0154 15.6391 27.4585 14.9502 27.4585Z",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6287 14.1131L22.054 6.63797C21.5656 6.15457 20.7758 6.16084 20.2924 6.65045C19.809 7.14006 19.8139 7.92867 20.3048 8.41207L25.718 13.7542H11.2126C10.5237 13.7542 9.9668 14.3111 9.9668 15.0001C9.9668 15.689 10.5237 16.2459 11.2126 16.2459H25.718L20.3048 21.5881C19.814 22.0715 19.8102 22.8601 20.2924 23.3497C20.5365 23.5964 20.858 23.721 21.1794 23.721C21.4959 23.721 21.8123 23.6014 22.054 23.3622L29.6287 15.8871C29.8654 15.6529 30 15.3339 30 15C30 14.6663 29.8667 14.3486 29.6287 14.1131Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.75601b055dd58eaec90fa8a841e54230.svg";
export { ForwardRef as ReactComponent };